import cn from "@/lib/cn";
import { ICON_THEME_COLOR, IconTheme } from "@/components/icons/theme";

interface IconPlusProps {
  theme?: IconTheme;
  className?: string;
  title?: string;
}

const THEME_COLOR = ICON_THEME_COLOR;

const IconPlus: React.FC<IconPlusProps> = ({
  theme = "white",
  className = "",
  title = "Plus icon",
}) => {
  const colorClass = THEME_COLOR[theme];

  return (
    <svg
      viewBox="0 0 14 14"
      fill="currentColor" // fill="#F6F6F9"
      xmlns="http://www.w3.org/2000/svg"
      aria-label={title}
      className={cn(className, colorClass)}
    >
      <path d="M14 6.25H7.75V0H6.25V6.25H0V7.75H6.25V14H7.75V7.75H14V6.25Z" />
    </svg>
  );
};

export default IconPlus;
